import { useEffect, useState } from 'react';
import axiosInstance from '../api/axiosInstance';

const baseUrl = process.env.REACT_APP_API_URL;

interface Merchant {
  id: number;
  company: string;
  address: string;
  contactPerson: string;
  createdAt: string;
  director: string;
  email: string;
  industry: string;
  locations: string;
  mobile: string;
  onlineShop: string;
  avgTxValue: string;
  taxId: string;
  telephone: string;
  currMonthVol: string;
  projMonthVolAcct: string;
  website: string;
}

const useMerchant = (id: string | undefined) => {
  const [merchant, setMerchant] = useState<Merchant | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!id) return;

    const fetchMerchant = async () => {
      try {
        const res = await axiosInstance.get(`${baseUrl}/admin/merchant/${id}`);
        setMerchant(res.data);
      } catch (err) {
        setError('Error fetching merchant data.');
      } finally {
        setLoading(false);
      }
    };

    fetchMerchant();
  }, [id]);

  return { merchant, loading, error };
};

export default useMerchant;
